import type { ContentBlock } from '@shared/ui/content';

export function timeToRead(blocks: ContentBlock[]): number {
  const words = blocks.reduce((acc, block) => {
    if (block.type === 'paragraph') {
      acc += block.data.text.split(' ').length;
    }

    return acc;
  }, 0);

  return Math.ceil(words / 200);
}
